import React from 'react'
import { FormControl, InputLabel, CircularProgress, Select, MenuItem } from '@material-ui/core'

const api = require('../api/api')

export default class FeedbackTab extends React.Component {
	constructor(props) {
		super(props)

		this.state = {
			data: null
		}
	}

	componentDidMount() {
		this.refresh()
	}

	refresh() {
		api.questions.listFeedback().then(data => {
			this.setState({
				data: data.feedback
			})
		}).catch(err => {
			console.error(err)
		})
	}

	render() {
		return <>
			{this.state.data ? Object.keys(this.state.data).map(i => {
				let data = this.state.data[i]

				return <div style={{ padding: 10, border: '1px solid lightgray', borderBottom: '3px solid lightgray', borderRadius: 10, marginBottom: 10 }}>
					Question: <b>{data.question}</b><br/>
					<FormControl style={{ width: 150 }}>
						<InputLabel id="select-label">State</InputLabel>
						<Select
							labelId="select-label"
							value={data.state}
							label="State"
							onChange={e => {
								data.state = e.target.value

								api.questions.updateFeedback({
									id: data.id,
									data: data
								}).then(() => {
									this.refresh()
								}).catch(e => {
									console.error(e)
								})
							}}
						>
							<MenuItem value={0}>TBR</MenuItem>
							<MenuItem value={1}>Pending</MenuItem>
							<MenuItem value={2}>Resolved</MenuItem>
						</Select>
					</FormControl>
					<br/><br/>
					
					Feedback: <i>{data.text}</i>
				</div>
			}) : <CircularProgress size={48} />}
		</>
	}
}